// src/config/app.config.ts

/**
 * Application Configuration
 * Centralized configuration for the AVEC Admin Dashboard
 */

// Application metadata
export const APP_CONFIG = {
  name: 'AVEC Admin Dashboard',
  version: '1.0.0',
  description: 'Administration dashboard for AVEC cooperative management',
};

// Feature flags
export const FEATURE_FLAGS = {
  enableDebugMode: process.env.NODE_ENV === 'development',
  enableTokenDebugger: process.env.NODE_ENV === 'development',
  enableInactivityLogout: true,
};

// Inactivity timeout configuration
export const INACTIVITY_CONFIG = {
  // Warning appears 1 minute before logout
  WARNING_TIME: 4 * 60 * 1000, // 4 minutes in milliseconds
  // Auto-logout after 5 minutes of inactivity
  LOGOUT_TIME: 5 * 60 * 1000, // 5 minutes in milliseconds
};

// UI Configuration
export const UI_CONFIG = {
  theme: {
    primaryColor: '#4ade80',
    borderRadius: 12,
  },
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: ['10', '20', '50', '100'],
  },
};

// Export default configuration
export default {
  APP_CONFIG,
  FEATURE_FLAGS,
  INACTIVITY_CONFIG,
  UI_CONFIG,
};
